import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Calendar, GraduationCap, ArrowRight, Sparkles } from 'lucide-react';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { Formation } from '../data/constants';
interface FormationCardProps {
  formation: Formation;
}
export function FormationCard({
  formation
}: FormationCardProps) {
  return <Card className={`flex flex-col h-full border-none hover:-translate-y-2 transition-all duration-500 overflow-hidden group bg-white ${formation.isNew ? 'shadow-2xl ring-2 ring-brand-orange hover:shadow-2xl' : 'shadow-lg hover:shadow-xl'}`} data-id="element-345" data-mp="2m0opntsetha5">
      <div className={`h-2 w-full transition-colors duration-500 ${formation.isNew ? 'bg-brand-orange' : 'bg-primary group-hover:bg-brand-orange'}`} data-id="element-346" data-mp="2zvr1exjxu0uv" />
      <CardHeader className="pt-8" data-id="element-347" data-mp="2qt2knpa5ch0m">
        <div className="flex flex-wrap gap-2 mb-4" data-id="element-348" data-mp="2qtcg3sdyngdp">
          {formation.isNew && <Badge variant="default" className="bg-brand-orange text-white hover:bg-brand-orange border-none font-bold uppercase tracking-wider flex items-center gap-1.5" data-id="element-349" data-mp="2m1uaus4wmtmx">
              <Sparkles className="w-3.5 h-3.5" data-id="element-350" data-mp="2d2qs5p9ngg8y" />
              Nouveauté
            </Badge>}
          <Badge variant="default" className="bg-lavande text-primary-dark hover:bg-lavande/80 border-none font-bold" data-id="element-351" data-mp="39qx30tx604vo">
            {formation.level}
          </Badge>
          <Badge variant="outline" className="text-muted-foreground border-slate-200" data-id="element-352" data-mp="30pywa3vcdj9e">
            {formation.rncp}
          </Badge>
        </div>
        <CardTitle className="text-2xl md:text-3xl leading-tight font-heading font-extrabold text-primary-dark group-hover:text-primary transition-colors" data-id="element-353" data-mp="1pcd8on54rppz">
          {formation.title}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 space-y-6" data-id="element-354" data-mp="1lvh3hdvq3gvl">
        <p className="text-muted-foreground text-lg leading-relaxed line-clamp-3" data-id="element-355" data-mp="1qta65wxthsr4">
          {formation.description}
        </p>
        <div className="space-y-3 pt-6 border-t border-slate-100 text-base text-muted-foreground" data-id="element-356" data-mp="1cuaj2tpydlx2">
          <div className="flex items-center gap-3 group/item" data-id="element-357" data-mp="1hrsssmbso564">
            <Clock className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-358" data-mp="133oahjgnlvnv" />
            <span className="font-medium" data-id="element-359" data-mp="17uefgvl63wi1">Durée : {formation.duration}</span>
          </div>
          <div className="flex items-center gap-3 group/item" data-id="element-360" data-mp="17w934hntq2pt">
            <Calendar className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-361" data-mp="u4b2kv86hf59" />
            <span className="font-medium" data-id="element-362" data-mp="y5ebsyvq0cxi">Rythme : {formation.rhythm}</span>
          </div>
          <div className="flex items-center gap-3 group/item" data-id="element-363" data-mp="k64yq82t9yxr">
            <GraduationCap className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-364" data-mp="p3n982wh8m7v" />
            <span className="font-medium" data-id="element-365" data-mp="5hleot179vnt">Rentrée : {formation.rentree}</span>
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex flex-col sm:flex-row gap-4 pt-8 pb-8" data-id="element-366" data-mp="k3eps55uqry">
        <Button variant="outline" className="w-full text-primary-dark border-primary/20 hover:bg-primary/5 font-semibold" asChild data-id="element-367" data-mp="fgu4rasy2q4w">
          <Link to={`/formations/${formation.id}`} data-id="element-368" data-mp="ajkk08gi32ne">Voir le programme</Link>
        </Button>
        <Button className="w-full group/btn bg-brand-orange hover:bg-[#E67E22] text-white font-semibold" asChild data-id="element-369" data-mp="oewb85vg6azk">
          <Link to="/candidater" data-id="element-370" data-mp="y723lgpm2ufa">
            Candidater
            <ArrowRight className="w-5 h-5 ml-2 group-hover/btn:translate-x-1 transition-transform" data-id="element-371" data-mp="y8vex9b662tm" />
          </Link>
        </Button>
      </CardFooter>
    </Card>;
}